<div class="integracao-resumo-carga" data-testid="integracao-resumo-carga">
  <div class="integracao-resumo-carga__item">
    <span class="integracao-resumo-carga__rotulo">Total de registros</span>
    <span class="integracao-resumo-carga__total" data-testid="log-resumo-total">
      {{ resumo().total }}
    </span>
  </div>

  <!-- As parcelas ficam num bloco à parte: na mesma faixa do total, ele parecia uma quarta
       fatia da barra em vez do número que as três somam. -->
  <div class="integracao-resumo-carga__parcelas">
    <div class="integracao-resumo-carga__parcelas-linha">
      @for (segmento of segmentos(); track segmento.chave) {
        <div class="integracao-resumo-carga__item">
          <span class="integracao-resumo-carga__rotulo">
            <span
              [class]="
                'integracao-resumo-carga__marcador integracao-resumo-carga__marcador--' +
                segmento.chave
              "
              aria-hidden="true"
            ></span>
            {{ segmento.rotulo }}
          </span>
          <span class="integracao-resumo-carga__medida">
            <span
              class="integracao-resumo-carga__valor"
              [attr.data-testid]="'log-resumo-' + segmento.chave"
            >{{ segmento.valor }}</span>
            <span class="integracao-resumo-carga__percentual">{{ segmento.percentual }}%</span>
          </span>
        </div>
      }
    </div>

    @if (cargaVazia()) {
      <p class="integracao-resumo-carga__vazio">Nenhum registro nesta carga.</p>
    } @else {
      <!-- A proporção já está nos números ao lado; para o leitor de tela a barra repetiria. -->
      <div class="integracao-resumo-carga__barra" aria-hidden="true">
        @for (segmento of segmentos(); track segmento.chave) {
          <span
            [class]="'integracao-resumo-carga__fatia integracao-resumo-carga__fatia--' + segmento.chave"
            [style.flex-grow]="segmento.valor"
          ></span>
        }
      </div>
    }
  </div>
</div>
